import currentConferencePhase from './experience/conference'
import currentCountdownPhase from './experience/countdown'
import currentRegistrationPhase from './experience/registration'
import currentExpoHallConfig from './feature/expoHall'
import callForContentConfig from './experience/callForContent'
import callForExhibitorsConfig from './experience/callForExhibitors'
import { afterConferenceConfig } from './experience'

const second = 1 * 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour

const conferenceConfig = {
  // Next conference year.
  year: '2026',
  2027: {
    preEventStart: '2026-02-25T07:00:00.000Z',
    attachmentsEditDeadline: '2027-02-22T05:59:59.000Z',
    callForContent: {
      starts: callForContentConfig.starts,
      submissionEnds: callForContentConfig.submissionEnds,
      approvalStarts: callForContentConfig.approvalStarts,
      sessionsDue: callForContentConfig.sessionsDue,
      syllabiAndSlidesDue: callForContentConfig.syllabiAndSlidesDue,
      ends: callForContentConfig.ends,
    },
    callForExhibitors: {
      starts: callForExhibitorsConfig.starts,
      // NOTE: Exhibitors can start editing booths once the expoHall is closed.
      dashboardAccessStarts: callForExhibitorsConfig.dashboard.opens,
      dashboardAccessEnds: callForExhibitorsConfig.dashboard.closes,
      submissionEnds: callForExhibitorsConfig.submissionEnds,
      acceptanceEnds: callForExhibitorsConfig.acceptanceEnds,
      promotionEditEnds: callForExhibitorsConfig.promotionEditEnds,
      ends: callForExhibitorsConfig.ends,
    },
    registration: {
      starts: currentRegistrationPhase.starts,
      pricing: {
        earlyBird: {
          starts: currentRegistrationPhase.pricing.earlyBird.starts,
          ends: currentRegistrationPhase.pricing.earlyBird.ends,
        },
        standard: {
          starts: currentRegistrationPhase.pricing.standard.starts,
          ends: currentRegistrationPhase.pricing.standard.ends,
        },
      },
      ends: currentRegistrationPhase.pricing.standard.ends,
    },
    expoHall: {
      starts: currentExpoHallConfig.opens,
      ends: currentExpoHallConfig.closes,
      promotions: {
        starts: currentExpoHallConfig.promotions.starts,
        ends: currentExpoHallConfig.promotions.ends,
      },
    },
    countdown: {
      starts: currentCountdownPhase.starts,
      ends: currentCountdownPhase.ends,
    },
    schedule: {
      // Should be the day registration starts
      previewStarts: currentRegistrationPhase.starts,
      // Should be the day countdown starts
      schedulingStarts: currentCountdownPhase.starts,
      // I think this should be the end of the participation window.
      archiveStarts: '',
    },
    participationWindow: {
      // Valentines
      starts: '2027-02-12T07:00:00-07:00',
      // April Fools
      ends: '2027-03-30T07:00:00-07:00',
    },
    conference: {
      starts: currentConferencePhase.starts,
      ends: currentConferencePhase.ends,
      inPerson: {
        starts: '2027-03-04T08:00:00-07:00',
        ends: '2027-03-06T17:00:00-07:00',
      },
      resources: {
        syllabiDownloadable: currentConferencePhase.resources.downloadable.syllabi,
        slidesDownloadable: currentConferencePhase.resources.downloadable.slides,
      },
    },
    discoveryDay: {
      starts: '2027-03-06T09:00:00-07:00',
      ends: '2027-03-06T15:00:00-07:00',
    },
    arcSymposium: {
      starts: '2027-03-03T09:00:00-07:00',
      ends: '2027-03-03T17:00:00-07:00',
    },
    afterConference: {
      starts: afterConferenceConfig.starts,
      ends: afterConferenceConfig.ends,
    },
    sponsors: {
      enableDashboard: '2026-09-01T06:00:00.000Z',
      deadline: '2027-02-18T07:00:00.000Z',
    },
    exhibitors: {
      deadline: '2027-02-18T07:00:00.000Z',
    },
  },
  2026: {
    preEventStart: '2025-02-26T07:00:00.000Z',
    attachmentsEditDeadline: '2027-02-22T05:59:59.000Z',
    callForContent: {
      starts: '2026-05-19T09:00:00-06:00',
      submissionEnds: '2025-06-30T23:59:59-06:00',
      approvalStarts: '2025-09-15T12:59:59-06:00',
      sessionsDue: '2025-12-08T23:59:59-07:00',
      syllabiAndSlidesDue: '2026-01-27T23:59:59-07:00',
      ends: '2026-02-25T07:00:00.000Z',
    },
    callForExhibitors: {
      starts: '2025-07-20T09:00:00-06:00',
      // NOTE: Exhibitors can start editing booths once the expoHall is closed.
      dashboardAccessStarts: '2025-10-06T18:00:00-06:00',
      dashboardAccessEnds: '2026-01-27T23:59:59-07:00',
      submissionEnds: '2025-12-08T23:59:59-07:00',
      acceptanceEnds: '2026-02-18T23:59:59-07:00',
      promotionEditEnds: '2026-02-09T07:00:00-07:00',
      ends: '2026-02-18T23:59:59-07:00',
    },
    registration: {
      starts: '2025-09-24T08:00:00-07:00',
      pricing: {
        earlyBird: {
          starts: '2025-09-24T08:00:00-07:00',
          ends: '2026-01-18T23:59:59-07:00',
        },
        standard: {
          starts: '2026-01-19T00:00:01-07:00',
          ends: '2026-03-07T18:00:00-07:00',
        },
      },
      ends: '2026-03-07T18:00:00-07:00',
    },
    expoHall: {
      starts: '2026-03-04T16:00:00-07:00',
      ends: '2026-08-14T18:00:00-06:00',
      promotions: {
        starts: '2026-03-05T05:00:00-07:00',
        ends: '2026-04-01T07:00:00-07:00',
      },
    },
    countdown: {
      starts: '2026-01-28T08:00:00-07:00',
      ends: '2026-03-07T18:00:00-07:00',
    },
    schedule: {
      // Should be the day registration starts
      previewStarts: '2025-09-24T08:00:00-07:00',
      // Should be the day countdown starts
      schedulingStarts: '2026-01-28T08:00:00-07:00',
      // I think this should be the end of the participation window.
      archiveStarts: '',
    },
    participationWindow: {
      // Valentines
      starts: '2026-02-14T07:00:00.000Z',
      // April Fools
      ends: '2026-04-01T07:00:00.000Z',
    },
    conference: {
      starts: '2026-03-05T08:00:00-07:00',
      ends: '2026-03-07T18:00:00-07:00',
      inPerson: {
        starts: '2026-03-05T08:00:00-07:00',
        ends: '2026-03-07T17:00:00-07:00',
      },
      resources: {
        syllabiDownloadable: '2026-02-26T09:00:00-07:00',
        slidesDownloadable: '2026-03-04T16:00:00-07:00',
      },
    },
    discoveryDay: {
      starts: '2026-03-07T09:00:00-07:00',
      ends: '2026-03-07T15:00:00-07:00',
    },
    arcSymposium: {
      starts: '2026-03-04T09:00:00-07:00',
      ends: '2026-03-04T17:00:00-07:00',
    },
    afterConference: {
      starts: '2026-03-07T18:00:00-07:00',
      ends: '2026-09-23T08:00:00-07:00',
    },
    sponsors: {
      enableDashboard: '2025-09-01T06:00:00.000Z',
      deadline: '2026-02-19T07:00:00.000Z',
    },
    exhibitors: {
      deadline: '2026-02-19T07:00:00.000Z',
    },
  },
  2025: {
    conference: {
      starts: '2025-03-06T16:00:00-07:00',
      ends: '2025-03-08T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2025-03-08T09:00:00-07:00',
      ends: '2025-03-08T15:00:00-07:00',
    },
  },
  2024: {
    conference: {
      starts: '2024-02-29T16:00:00-07:00',
      ends: '2024-03-02T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2024-03-02T09:00:00-07:00',
      ends: '2024-03-02T15:00:00-07:00',
    },
  },
  2023: {
    conference: {
      starts: '2023-03-02T16:00:00-07:00',
      ends: '2023-03-04T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2023-03-04T09:00:00-07:00',
      ends: '2023-03-04T15:00:00-07:00',
    },
  },
  2022: {
    conference: {
      starts: '2022-03-03T16:00:00-07:00',
      ends: '2022-03-05T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2022-03-05T09:00:00-07:00',
      ends: '2022-03-05T15:00:00-07:00',
    },
  },
  2021: {
    conference: {
      starts: '2021-02-25T16:00:00-07:00',
      ends: '2021-02-27T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2021-02-27T09:00:00-07:00',
      ends: '2021-02-27T15:00:00-07:00',
    },
  },
  2020: {
    conference: {
      starts: '2020-02-26T16:00:00-07:00',
      ends: '2020-02-29T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2020-02-29T09:00:00-07:00',
      ends: '2020-02-29T15:00:00-07:00',
    },
  },
  2019: {
    conference: {
      starts: '2019-03-27T16:00:00-07:00',
      ends: '2019-03-30T18:00:00-07:00',
      london: {
        starts: '2019-10-24T16:00:00Z',
        ends: '2019-10-26T18:00:00Z',
      },
    },
    discoveryDay: {
      starts: '2019-03-30T16:00:00-07:00',
      ends: '2019-03-30T18:00:00-07:00',
      london: {
        starts: '2019-10-26T09:00:00Z',
        ends: '2019-10-26T15:00:00Z',
      },
    },
  },
  2018: {
    conference: {
      starts: '2018-02-28T16:00:00-07:00',
      ends: '2018-03-03T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2018-03-03T09:00:00-07:00',
      ends: '2018-03-03T15:00:00-07:00',
    },
  },
  2017: {
    conference: {
      starts: '2017-02-08T16:00:00-07:00',
      ends: '2017-02-11T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2017-02-11T09:00:00-07:00',
      ends: '2017-02-11T15:00:00-07:00',
    },
  },
  2016: {
    conference: {
      starts: '2016-02-03T16:00:00-07:00',
      ends: '2016-02-06T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2016-02-06T09:00:00-07:00',
      ends: '2016-02-06T15:00:00-07:00',
    },
  },
  2015: {
    conference: {
      starts: '2015-02-12T16:00:00-07:00',
      ends: '2015-02-14T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2015-02-14T09:00:00-07:00',
      ends: '2015-02-14T15:00:00-07:00',
    },
  },
  2014: {
    conference: {
      starts: '2014-02-06T16:00:00-07:00',
      ends: '2014-02-08T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2014-02-08T09:00:00-07:00',
      ends: '2014-02-08T15:00:00-07:00',
    },
  },
  2013: {
    conference: {
      startDate: '2013-03-21T16:00:00-07:00',
      endDate: '2013-03-23T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2013-03-23T09:00:00-07:00',
      ends: '2013-03-23T15:00:00-07:00',
    },
  },
  2012: {
    conference: {
      starts: '2012-02-02T16:00:00-07:00',
      ends: '2012-02-04T18:00:00-07:00',
    },
  },
  2011: {
    conference: {
      starts: '2011-02-10T16:00:00-07:00',
      endDate: '2011-02-12T18:00:00-07:00',
    },
  },

  // CURRENT CONFERENCE DATES
  ...(() => {
    const startDate = new Date(currentConferencePhase.starts)
    return {
      startYear: startDate.getFullYear().toString(),
      startTimestamp: startDate.getTime(),
      endTimestamp: new Date(currentConferencePhase.ends).getTime(),
    }
  })(),

  cfcTimezone: 'America/Denver',
  cfcYear: (new Date(callForContentConfig.starts).getFullYear() + 1).toString(),

  playerTimeFrame: 42 * day,

  // PROMOTIONS
  promotionsEditDeadlineTimestamp: new Date(currentExpoHallConfig.promotions.editDeadline).toISOString(),
  promotionsStartTimestamp: new Date(currentExpoHallConfig.promotions.starts).toISOString(),
  promotionsEndTimestamp: new Date(currentExpoHallConfig.promotions.ends).toISOString(),

  // DOWNLOADABLE RESOURCES
  dlrEditDeadlineTimestamp: '2027-02-28T07:00:00.000Z',

  // HIGH RESOLUTION LOGOS
  hrlEditDeadlineTimestamp: '2027-02-28T07:00:00.000Z',

  // MAIN STAGE UPLOAD
  mainStageUploadDeadlineTimestamp: '2027-03-01T07:00:00.000Z',

  // CALL FOR PRESENTATIONS
  cfpEndTimestamp: callForContentConfig.sessionsDue,

  // PROFILES
  profilesCreationDeadlineTimestamp: '2027-02-06T07:00:00.000Z',

  // SCHEDULE
  classPreviewTimestamp: currentRegistrationPhase.starts,

  // BOOTH
  enableSponsorsEditBoothTimestamp: callForExhibitorsConfig.dashboard.opens,
  boothEditDeadlineTimestamp: callForExhibitorsConfig.dashboard.closes,
}

export { second, minute, hour, day, conferenceConfig }
